import { render, staticRenderFns } from "./RequisicaoCampoComponent.vue?vue&type=template&id=367b4907"
import script from "./RequisicaoCampoComponent.vue?vue&type=script&lang=js"
export * from "./RequisicaoCampoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports